var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sale-plan-list',{directives:[{name:"show",rawName:"v-show",value:(_vm.action === 'list'),expression:"action === 'list'"}],on:{"change-action":_vm.changeAction}}),_vm._v(" "),(_vm.action === 'detail')?_c('sale-plan-detail',{attrs:{"plan-num":_vm.planNum},on:{"change-action":_vm.changeAction}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afe4b7cc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/sale-plan-manage/salePlanTotalList.vue
// module id = null
// module chunks = 